import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { SortOrder } from '@/components/ui/table'
import { ChecklistStatus, ChecklistType } from '@/models/features'

import { authAPI } from '../new-api'

export interface GetChecklistsResidentsRequest {
  buildingId?: number
  skip?: number
  limit?: number
  status?: ChecklistStatus
  search?: string
  type?: ChecklistType
  parentChecklistId?: number[]
  clientId?: number[]
  fromDate?: number
  toDate?: number
  unitId?: number
  sortBy?: string
  sortOrder?: SortOrder
}

export interface GetChecklistsResidentsResponse {
  data: {
    clientId: number
    name: string
    count: number
  }[]
  total: number
  skip: number
  limit: number
  hasMore: boolean
}

export const getChecklistsResidentsQueryKey = (data: GetChecklistsResidentsRequest) => [
  'useGetChecklistsResidents',
  data,
]

export const getChecklistsResidents = async (
  data: GetChecklistsResidentsRequest,
  signal?: AbortSignal,
) => {
  const { buildingId, ...params } = data
  const response = await authAPI.get<GetChecklistsResidentsResponse>(
    `/checklist-unified/counts/${buildingId}/client`,
    { params, signal },
  )
  return response.data
}

export const useGetChecklistsResidents = (data: GetChecklistsResidentsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    gcTime: 0,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getChecklistsResidents(data, signal),
    queryKey: getChecklistsResidentsQueryKey(data),
  })
}
